module.exports = __webpack_public_path__ + "static/pokedex-9eb8c5cd836051a44475c8f8cd7dd14f.png";